import {useEffect, useState} from 'react';
import useGoToNavigation from '../../util/useGotoNavigation';
import {useTranslation} from 'react-i18next';
import {LanguageDropdown} from '../common/LanguageDropdown';
import {userAccount} from '../../types/user/userAccountInterface';
import {sendPasswordResetEmailApi} from '../../api/user/UserApi';
import {useMutation} from "@tanstack/react-query";

const req: userAccount = {
    loginId: "",
    password: "",
    passwordChk: "",
}

export const PasswordReset1 = () => {
    const {t} = useTranslation();

    const {goToNavigation} = useGoToNavigation();

    const [resetPwReq, setResetPwReq] = useState(req);

    const [isValid, setisValid] = useState(true);
    const [isSame, setIsSame] = useState(true);

    const pwChangeApi = () => {
        if (resetPwReq.loginId === "") {
            setisValid(false)
            return;
        }

        sendPasswordResetEmailApiMutate.mutate();
    }

    const sendPasswordResetEmailApiMutate = useMutation({
        mutationFn: () => sendPasswordResetEmailApi(resetPwReq),
        onSuccess: res => {
            if (res.data.code === "0000") {
                goToNavigation('login/pass_reset2', {email: resetPwReq.loginId}, true)
            } else {
                setIsSame(false)
            }
        }
    });


    useEffect(() => {
        setIsSame(true)
        setisValid(true)
    }, [resetPwReq])

    return (
        <>
            <div>
            </div>
            <div className="login_content">
                <div className="login_lang_outer">
                    <LanguageDropdown/>

                </div>
                <div className="login_box">
                    <img src={process.env.PUBLIC_URL + "/assets/images/login_logo.png"} alt=""/>
                    <p className="text_password_reset line1">
                        {t('pwReset1-resetpw-label')}
                    </p>
                    <p className="text_password_reset line2">
                        {t('pwReset1-resetpw-desc1')}
                    </p>
                    <div className="frm_login_row">
                        <label className="form-label">{t('pwReset1-resetpw-email')}</label>
                        <div className="input-group">
                            <span className="input-group-text">
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_login_input1.png"} alt=""/>
                            </span>
                            <input type="text"
                                   className="form-control"
                                   value={resetPwReq.loginId}
                                   onChange={(e) => setResetPwReq({...resetPwReq, loginId: e.target.value})}
                                   onKeyDown={(e) => e.key === "Enter" ? pwChangeApi() : ""}
                                   placeholder={t('pwReset1-resetpw-input')}/>
                        </div>
                    </div>
                    {!isValid ?
                        <div className="error-messageLogin">{t('pwReset1-resetpw-validation')}</div>
                        :
                        !isSame ?
                            <div className="error-messageLogin">{t('pwReset1-resetpw-validation2')}</div>
                            : ""
                    }


                    <button className="btn btn-info btn-lg btn_login"
                            onClick={pwChangeApi}>{t('pwReset1-btn-label')}</button>
                </div>
            </div>
        </>
    );
}